import React, { useEffect } from 'react';
import { PartnerButton } from './partnerButton';
import * as Containers from './partnerContainers';

export const PartnersScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Containers.RemoveBackgroundAddMenu>
            <Containers.Container>
                <Containers.ContainerRow>
                    <Containers.TitleImage src='/images/partners/hero.png' />

                    <Containers.PartnerParagraph>
                        WeatherBug partners with strategic companies to help leverage data, insights and better performance for our users.
                        <br/>
                        Interested in becoming a WeatherBug Partner?
                    </Containers.PartnerParagraph>
                    <Containers.ButtonContainer>
                        <PartnerButton />
                    </Containers.ButtonContainer>
                </Containers.ContainerRow>
                <Containers.ContainerRow>
                    <Containers.Title>
                        Strategic Partner
                    </Containers.Title>
                </Containers.ContainerRow>
                <Containers.ContainerRow>
                    <Containers.PartnerContainer>
                        <Containers.PartnerImageDiv>
                            <Containers.PartnerImage src='/images/partners/opensignal.png'/>
                        </Containers.PartnerImageDiv>
                        <Containers.PartnerText>
                            We’ve partnered with Opensignal to help improve the performance and reliability of this app and your wireless networks while respecting your privacy.
                            Opensignal does not collect any information that directly identifies you or your device, and does not sell any personal data about you.
                            Opensignal may collect data relating to the wireless network performance your device experiences, that may include: location, network performance information and identifiers (e.g. signal strength, network names, resettable IDs, BSSIDs, and other access point information), and app state.
                            Some network traffic is generated to test network and video streaming speeds.
                            Opensignal is a world leader in helping telecom ecosystem companies better understand and improve network coverage to improve connectivity.
                            They use this data to gather information on network experience and create aggregated reports and/or data solutions including anonymized location, for example by plotting network performance on a map to convey coverage.
                            <p>You can learn more about Opensignal's privacy policy
                                &nbsp;<a href='https://www.opensignal.com/privacypolicy-for-crowdsourcedata' rel='noopener noreferrer' target='_blank'>here</a>.
                                In order to opt-out of the collection and use of your data by Opensignal, please visit the About page in the left side menu on our mobile applications. The Opensignal SDK is not deployed in the Elite version of the app.</p>
                        </Containers.PartnerText>
                    </Containers.PartnerContainer>
                </Containers.ContainerRow>
                <Containers.ContainerRow>
                    <Containers.PartnerContainer>
                        <Containers.PartnerImageDiv>
                            <Containers.PartnerImage src='/images/partners/placer.png'/>
                        </Containers.PartnerImageDiv>
                        <Containers.PartnerText>
                                We may disclose your location data and other data related to your device to Placer Labs Inc. via their location data market research platform, to help us and them better understand your interests and improve products. 
                                Placer Labs Inc. may use aggregated or anonymized versions of the data they receive to provide market research and other data analytics services to their customers. 
                                You can withdraw your consent to having your location data collected by changing the settings on your device. For more information, please see Placer’s Privacy Policy for Consumers.
                        </Containers.PartnerText>
                    </Containers.PartnerContainer>
                </Containers.ContainerRow>
            </Containers.Container>
        </Containers.RemoveBackgroundAddMenu>
    );
}

